import React, { Children } from 'react';
import cn from 'classnames';
import { ROLES } from './constants';
import { isTab } from './helpers.js';

const TabList = ({ children, className = '', tabClassName }) => (
  <ul role="tablist" className={cn('TabbedView-tabList', className)}>
    {Children.map(children, child => {
      if (isTab(child)) {
        return React.cloneElement(child, { className: tabClassName });
      }

      return child;
    })}
  </ul>
);

TabList.role = ROLES.TAB_LIST;

export default TabList;
